export const iconFontAwesomeGamingDiceTwo = (
	<i className="fa-solid fa-dice-two"></i>
);
